import React, {Component} from 'react';
import Autosuggest from 'react-autosuggest';
import '../css/components/autosuggest.css';

const baseStyle = 'textfield-bbva textfield-cuentas__div-textfield';
const styleError = `${baseStyle} bg-sphericaSecondary input--error`;
const styleNormal = `${baseStyle}  bg-sphericaSecondary`;
class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.text,
      suggestions: [],
      className: styleNormal,
    };
  }

  componentDidMount() {
    const label = document.createElement('label');
    label.textContent = this.props.placeholder;
    label.setAttribute('htmlFor', this.props.id);
    label.classList.add('input__label');
    document.getElementById(this.props.id).parentElement.appendChild(label);
  }

  onChange = (event, {newValue, method}) => {
    if(newValue === '' || this.props.pattern.test(newValue)){
      this.setState({value: newValue, className: styleNormal});
    }
  };

  onBlur = (event, {highlightedSuggestion}) => {
    this.props.onBlur(this.state.value);
  };

  onClick = (event) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  clearClick = (e) => {
    this.setState({value: ''});
    const event = {
      target: {
        value: '',
        name: this.props.name,
        id: this.props.id,
      },
      bubbles: true,
      cancelable: true
    };
    this.onChange(event, { newValue: '', method: 'clear' });
  }

  onPaste = (e) => {
    e.preventDefault();
  }

  onSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
    this.props.onSelected(suggestion);
  };

  onSuggestionsFetchRequested = ({value}) => {
    this.setState({suggestions: this.props.getSuggestions(value)});
  };

  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []});
  };

  setClassName(isValido) {
    this.setState({className: isValido ? styleNormal : styleError});
  }

  getSuggestionValue = (suggestion) => {
    if ('distrito' in suggestion) {
      return suggestion['distrito'] + ', ' + suggestion['provincia'] + ', ' + suggestion['departamento'] + ' (' + suggestion['count'] + ')';
    } else if ('nombreDistrito' in suggestion) {
      return suggestion['nombreDistrito'] + ', ' + suggestion['nombreProvincia'] + ', ' + suggestion['nombreDepartamento'];
    } else {
      return suggestion['email'];
    }
  };

  renderSuggestion = (suggestion) => {
    if ('distrito' in suggestion) {
      return (
        <label>
          {suggestion['distrito']}, {suggestion['provincia']}, {suggestion['departamento']} ({suggestion['count']})
        </label>
      );
    } else if ('nombreDistrito' in suggestion) {
      return (
        <label>
          {suggestion['nombreDistrito']}, {suggestion['nombreProvincia']}, {suggestion['nombreDepartamento']}
        </label>
      );
    } else {
      return <label>{suggestion['email']}</label>;
    }
  };

  render() {
    const inputProps = {
      disabled: this.props.disabled ? true : false,
      value: this.state.value,
      onChange: this.onChange,
      onBlur: this.onBlur,
      id: this.props.id,
      name: this.props.name,
      className: this.state.className,
      onClick: this.onClick,
      placeholder: ' ',
      onPaste: this.onPaste
    };

    let clearElement = (
        this.state.value ? (
          <span
            style={{ color: this.state.className === styleError ? 'var(--color-dark-red)' : 'var(--color-dark-blue)' }}
            onClick={this.clearClick}
          >
            x
          </span>
        ) : ('')
    );

    return (
      <React.Fragment>
        <span className="deleteicon">
          <Autosuggest
            suggestions={this.state.suggestions}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            inputProps={inputProps}
            onSuggestionSelected={this.onSuggestionSelected}
          />
          {clearElement}
        </span>
        
        </React.Fragment>
    );
  }
}

export default Autocomplete;
